const showdownUrlRegex = /\[([\S ]*?)]\s?\( *<?([^\s'"]*?(?:\([\S]*?\)[\S]*?)?)>?\s*(?:()(['"])(.*?)\5)? *\)/g

export const getShowdownLinkHtml = (value: string) => {
  return value.replace(
    showdownUrlRegex,
    (_match: string, linkText, href) =>
      `<a href='${href}' target='_blank'>${linkText}</a>`
  )
}
